export const carouselDownIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.7121 32.4657C37.2345 31.9881 36.4629 31.9881 35.9852 32.4657L29.641 38.8221V14.3395C29.641 13.6659 29.0899 13.1147 28.4163 13.1147C27.7427 13.1147 27.1916 13.6659 27.1916 14.3395V38.8221L20.8351 32.4657C20.3575 31.9881 19.5859 31.9881 19.1082 32.4657C18.6306 32.9434 18.6306 33.715 19.1082 34.1926L27.5467 42.6311C27.657 42.7413 27.7917 42.8393 27.9386 42.9005C28.0856 42.9618 28.2448 42.9985 28.4041 42.9985C28.5633 42.9985 28.7225 42.9618 28.8817 42.9005C29.0287 42.8393 29.1634 42.7536 29.2736 42.6311L37.7121 34.1926C38.1898 33.715 38.1898 32.9434 37.7121 32.4657Z"
      fill="#FFAFB8"
    />
  </svg>
);

export const carouselLeftIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/*
      Safari ignores transforms on the root <svg> element.
      Need to apply the transform to an inner <g> group.
      The matrix flips the icon horizontally.
    */}
    <g transform="matrix(-1 0 0 1 56 0)">
      <path
        d="M43.2467 28.1904C43.308 28.0434 43.3447 27.8842 43.3447 27.725C43.3447 27.5658 43.308 27.4065 43.2467 27.2596C43.1855 27.1126 43.0998 26.9779 42.9773 26.8677L34.5388 18.4292C34.0611 17.9515 33.2896 17.9515 32.8119 18.4292C32.3343 18.9068 32.3343 19.6784 32.8119 20.1561L39.1683 26.5002H14.6857C14.0121 26.5002 13.4609 27.0514 13.4609 27.725C13.4609 28.3986 14.0121 28.9497 14.6857 28.9497H39.1683L32.8119 35.3061C32.3343 35.7838 32.3343 36.5554 32.8119 37.033C33.0569 37.278 33.363 37.3882 33.6815 37.3882C33.9999 37.3882 34.3061 37.2657 34.551 37.033L42.9895 28.5945C43.0998 28.4843 43.1977 28.3496 43.259 28.2026L43.2467 28.1904Z"
        fill="#FFAFB8"
      ></path>
    </g>
  </svg>
);

export const carouselRightIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.2467 28.1904C43.308 28.0434 43.3447 27.8842 43.3447 27.725C43.3447 27.5658 43.308 27.4065 43.2467 27.2596C43.1855 27.1126 43.0998 26.9779 42.9773 26.8677L34.5388 18.4292C34.0611 17.9515 33.2896 17.9515 32.8119 18.4292C32.3343 18.9068 32.3343 19.6784 32.8119 20.1561L39.1683 26.5002H14.6857C14.0121 26.5002 13.4609 27.0514 13.4609 27.725C13.4609 28.3986 14.0121 28.9497 14.6857 28.9497H39.1683L32.8119 35.3061C32.3343 35.7838 32.3343 36.5554 32.8119 37.033C33.0569 37.278 33.363 37.3882 33.6815 37.3882C33.9999 37.3882 34.3061 37.2657 34.551 37.033L42.9895 28.5945C43.0998 28.4843 43.1977 28.3496 43.259 28.2026L43.2467 28.1904Z"
      fill="#FFAFB8"
    />
  </svg>
);

export const carouselUpIcon = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/*
      Safari ignores transforms on the root <svg> element.
      Need to apply the transform to an inner <g> group.
      The matrix flips the icon vertically.
    */}
    <g transform="matrix(1, 0, 0, -1, 0, 56)">
      <path
        d="M37.7121 32.4657C37.2345 31.9881 36.4629 31.9881 35.9852 32.4657L29.641 38.8221V14.3395C29.641 13.6659 29.0899 13.1147 28.4163 13.1147C27.7427 13.1147 27.1916 13.6659 27.1916 14.3395V38.8221L20.8351 32.4657C20.3575 31.9881 19.5859 31.9881 19.1082 32.4657C18.6306 32.9434 18.6306 33.715 19.1082 34.1926L27.5467 42.6311C27.657 42.7413 27.7917 42.8393 27.9386 42.9005C28.0856 42.9618 28.2448 42.9985 28.4041 42.9985C28.5633 42.9985 28.7225 42.9618 28.8817 42.9005C29.0287 42.8393 29.1634 42.7536 29.2736 42.6311L37.7121 34.1926C38.1898 33.715 38.1898 32.9434 37.7121 32.4657Z"
        fill="#FFAFB8"
      />
    </g>
  </svg>
);

export const moreIconPink200 = (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14.5C0 6.76801 6.26801 0.5 14 0.5C21.732 0.5 28 6.76801 28 14.5C28 22.232 21.732 28.5 14 28.5C6.26801 28.5 0 22.232 0 14.5Z"
      fill="#FFD7DC"
    />
    <path
      d="M21.575 14.7375C21.6063 14.6625 21.625 14.5812 21.625 14.5C21.625 14.4187 21.6063 14.3375 21.575 14.2625C21.5438 14.1875 21.5 14.1187 21.4375 14.0625L17.1313 9.75624C16.8875 9.51249 16.4938 9.51249 16.25 9.75624C16.0063 9.99999 16.0063 10.3937 16.25 10.6375L19.4938 13.875H7C6.65625 13.875 6.375 14.1562 6.375 14.5C6.375 14.8437 6.65625 15.125 7 15.125H19.4938L16.25 18.3687C16.0063 18.6125 16.0063 19.0062 16.25 19.25C16.375 19.375 16.5312 19.4312 16.6938 19.4312C16.8562 19.4312 17.0125 19.3687 17.1375 19.25L21.4438 14.9437C21.5 14.8875 21.55 14.8187 21.5813 14.7437L21.575 14.7375Z"
      fill="#4C3437"
    />
  </svg>
);

export const moreIconPinkBrand = (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14.5C0 6.76801 6.26801 0.5 14 0.5C21.732 0.5 28 6.76801 28 14.5C28 22.232 21.732 28.5 14 28.5C6.26801 28.5 0 22.232 0 14.5Z"
      fill="#FFAFB8"
    />
    <path
      d="M21.575 14.7375C21.6063 14.6625 21.625 14.5812 21.625 14.5C21.625 14.4187 21.6063 14.3375 21.575 14.2625C21.5438 14.1875 21.5 14.1187 21.4375 14.0625L17.1313 9.75624C16.8875 9.51249 16.4938 9.51249 16.25 9.75624C16.0063 9.99999 16.0063 10.3937 16.25 10.6375L19.4938 13.875H7C6.65625 13.875 6.375 14.1562 6.375 14.5C6.375 14.8437 6.65625 15.125 7 15.125H19.4938L16.25 18.3687C16.0063 18.6125 16.0063 19.0062 16.25 19.25C16.375 19.375 16.5312 19.4312 16.6938 19.4312C16.8562 19.4312 17.0125 19.3687 17.1375 19.25L21.4438 14.9437C21.5 14.8875 21.55 14.8187 21.5813 14.7437L21.575 14.7375Z"
      fill="#4C3437"
    />
  </svg>
);
